import { z } from 'zod';
import { LocalizedStringSchema, MoneySchema, TimestampFieldsSchema } from './common';

// ─── Catalog Item Type ────────────────────────────────────────────────────────
// Generic — สินค้า, บริการ, เมนูอาหาร, คอร์สเรียน, สถานที่

export const CatalogItemTypeSchema = z.enum([
  'product',      // ร้านค้า — สินค้า
  'service',      // คลินิก/ฟิตเนส/สปา — บริการ
  'menu_item',    // ร้านอาหาร — เมนูอาหาร/เครื่องดื่ม
  'course',       // สถาบัน — คอร์สเรียน
  'facility',     // สถานที่/สนาม — บริการเช่าใช้
  'custom',       // กำหนดเอง
]);
export type CatalogItemType = z.infer<typeof CatalogItemTypeSchema>;

// ─── Catalog Item Schema ──────────────────────────────────────────────────────

export const CatalogItemSchema = z
  .object({
    id: z.string(),
    tenantId: z.string(),
    type: CatalogItemTypeSchema.default('product'),
    code: z.string().optional(),          // SKU / Service code

    name: LocalizedStringSchema,
    description: LocalizedStringSchema.optional(),

    price: MoneySchema,
    originalPrice: MoneySchema.optional(), // ราคาเต็มก่อนส่วนลด

    category: z.string().optional(),       // เช่น "อาหารจานเดียว", "ทรีตเมนต์หน้า", "รองเท้า"
    imageUrl: z.string().url().optional(),
    tags: z.array(z.string()).default([]),

    inStock: z.boolean().default(true),
    stockQuantity: z.number().int().optional(),

    isActive: z.boolean().default(true),
    customFields: z.record(z.string(), z.unknown()).default({}),
  })
  .merge(TimestampFieldsSchema);

export type CatalogItem = z.infer<typeof CatalogItemSchema>;

export const CreateCatalogItemInputSchema = CatalogItemSchema.omit({
  id: true,
  createdAt: true,
  updatedAt: true,
});
export type CreateCatalogItemInput = z.infer<typeof CreateCatalogItemInputSchema>;
